import { Button, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import axios from "../axios";
import { useForm, Controller } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { queryClient } from "../index";

const NewTeacher = () => {
  const { register, handleSubmit, control } = useForm({
    defaultValues: {
      name: "",
      address: "",
      nic: "",
      startedDate: dayjs(),
      email: "",
      phone: "",
      subjects: "",
      otherPositions: "",
      qualifications: "",
      experience: "",
      password: "",
    },
  });
  const navigate = useNavigate();

  const addTeacherMutation = useMutation((data) =>
    axios.post("/teachers", data)
  );

  const handleFormSubmission = (data) => {
    addTeacherMutation.mutate(
      {
        ...data,
        startedDate: dayjs(data.startedDate).format("YYYY-MM-DD"),
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries("teachers");
          toast.success("Teacher added successfully");
          navigate("/teachers");
        },
        onError: (err) => {
          toast.error(
            err.response?.data?.message || "Error adding teacher"
          );
        },
      }
    );
  };

  return (
    <div>
      <Typography mb={2} variant="h5" component="h2">
        New Teacher
      </Typography>
      <Box
        onSubmit={handleSubmit(handleFormSubmission)}
        component="form"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        autoComplete="off"
      >
        {/* Personal Information */}
        <Box>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
            Personal Information
          </Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2 }}>
            <TextField required label="Full Name" {...register("name")} />
            <TextField required label="NIC" {...register("nic")} />
            <TextField
              required
              label="Email"
              type="email"
              autoComplete="new-email"
              {...register("email")}
            />
            <TextField required label="Phone" {...register("phone")} />
            <TextField
              required
              label="Address"
              multiline
              minRows={3}
              sx={{ gridColumn: "1 / -1" }}
              {...register("address")}
            />
          </Box>
        </Box>

        {/* Professional Details */}
        <Box>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
            Professional Details
          </Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2 }}>
            <Controller
              render={({ field }) => (
                <DatePicker
                  {...field}
                  label="Started Date"
                  inputFormat="DD-MM-YYYY"
                  renderInput={(params) => <TextField {...params} required />}
                />
              )}
              control={control}
              name="startedDate"
            />
            <TextField required label="Subjects" {...register("subjects")} />
            <TextField
              required
              label="Qualifications"
              {...register("qualifications")}
            />
            <TextField
              required
              label="Experience"
              {...register("experience")}
            />
            <TextField
              label="Other Positions"
              {...register("otherPositions")}
            />
          </Box>
        </Box>

        {/* Account Setup */}
        <Box>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
            Account Setup
          </Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2 }}>
            <TextField
              required
              label="Password"
              type="password"
              autoComplete="new-password"
              {...register("password")}
            />
          </Box>
        </Box>

        <Button type="submit" variant="contained" sx={{ alignSelf: "flex-end", px: 5 }}>
          Submit
        </Button>
      </Box>
    </div>
  );
};

export default NewTeacher;
